/* unplugin-vue-components disabled */import { render } from "./LogicalQuestionView.vue?vue&type=template&id=6c70c223&scoped=true"
import script from "./LogicalQuestionView.vue?vue&type=script&lang=js"
export * from "./LogicalQuestionView.vue?vue&type=script&lang=js"

import "./LogicalQuestionView.vue?vue&type=style&index=0&id=6c70c223&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c70c223"]])

export default __exports__